import { useDictionary } from '@adamlip/okeoke.client';
import SubmittedOrderItem from 'components/SubmittedOrder/SubmittedOrderItem';
import BeatLoader from 'react-spinners/BeatLoader';

function SubmittedOrderItemList(props) {
  const { className, details, order } = props;

  const { getValue } = useDictionary();

  const items = Object.values(order?.items || {});

  if (items.length < 1)
    return (
      <div className='loading-container hidden-content appear'>
        <BeatLoader color={'grey'} />
      </div>
    );

  return (
    <div className={`submitted-orderItemList-root ${className != null && className}`}>
      {items
        .filter((item) => item.count > 0)
        .map((item) => (
          <SubmittedOrderItem key={item.orderItemUUID} item={item} details={details} />
        ))}
      {order?.serviceFee?.total != null && order?.serviceFee?.total > 0 && (
        <div className='submitted-orderItem-root service-fee'>
          <div className='submitted-orderItem-header'>
            <div className='submitted-orderItem-name'>
              <div className='submitted-orderItem-size'></div>
              <div className='submitted-orderItem-itemName'>
                {order?.serviceFee?.type === 1 && `${getValue('app_v2_serviceFee')} (${order?.serviceFee?.percent}%)`}
                {order?.serviceFee?.type === 2 && getValue('app_v2_reverseServiceFee')}
              </div>
            </div>
            {order?.serviceFee?.type === 1 && <div className='submitted-orderItem-price'>{order?.serviceFee?.total} Ft</div>}
            {order?.serviceFee?.type === 2 && <div className='submitted-orderItem-price'>{order?.serviceFee?.percent} %</div>}
          </div>
        </div>
      )}
    </div>
  );
}

export default SubmittedOrderItemList;
